module.exports = __webpack_public_path__ + "static/img/Saint-Quentin-en-Yvelines-Velodrome.1ee157f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Saint-Quentin-en-Yvelines-Velodrome.jpg
// module id = 68a+
// module chunks = 0